import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Document} from '../../../models/browseDocuments.model';
import {DocTypeToken, FileService} from '../../../_services/api/file.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-video-file-item',
  templateUrl: './video-file-item.component.html',
  styleUrls: ['./video-file-item.component.scss']
})
export class VideoFileItemComponent implements OnInit {
  @Input() document: Document;
  @Output() deleteDocument: EventEmitter<Document> = new EventEmitter();
  @ViewChild('thumbnail') myElement: ElementRef;
  @Output() downloadDocument: EventEmitter<DocTypeToken[]> = new EventEmitter();
  @Output() shareDocument: EventEmitter<Document> = new EventEmitter<Document>();

  constructor(private fileService: FileService, private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  delete() {
    this.deleteDocument.emit(this.document);
  }

  download() {
    const docIds: DocTypeToken[] = [
      {
        tokens: [this.document.docId], type: 'video'
      }
    ];
    this.downloadDocument.emit(docIds);
  }

  selectByClick(): void {
    this.document.selection.isSelected = !this.document.selection.isSelected;
  }

  share() {
    this.shareDocument.emit(this.document);
  }
}
